'use strict';

// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const reverseEasing = (easing) => (p) => 1 - easing(1 - p);

exports.reverseEasing = reverseEasing;
//# sourceMappingURL=reverse.cjs.map
